import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const CurrenciesList = () => {
    const data = {
        url: '/admin/settings/payment_terms',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        onclick: 'link',
        link: '/settings/payment_terms/{id}',
        metadata: [
            {
                source: 'id',
                label: 'Payment Term ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'name',
                label: 'Name',
                type: 'text',
            },
            {
                source: 'description',
                label: 'Description',
                type: 'text',
            },
            {
                source: 'days_cycle',
                label: 'Cycle Days',
                type: 'number',
            },
            {
                source: 'days_grace',
                label: 'Grace Days',
                type: 'number',
            },
            {
                source: 'days_notify',
                label: 'Notify Days',
                type: 'text',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Payment Terms">
            <DataResource
                addButtonText = "Create Payment Term"
                addButtonLink = "/settings/payment_terms/create"                    
                data = {data}
            />
        </Panel>
    )
}

export default CurrenciesList;